// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createSelector, Selector } from 'reselect';
import { ModuleType, Module, Chapter, Progress, Note } from '../../../types/Model';
import { RootState } from '../../rootReducer';

export const workshopContentsRaw = (state: RootState) => state.workshopContentsDataReducer

/**
 * when fetching, set loading state
 */
export const makeIsFetchingWorkshopContentsData = () => {
  return createSelector(
    workshopContentsRaw,
    (workshopChapterReducer) => workshopChapterReducer.isLoading
  );
};

/**
 * when error, set error state
 */
export const makeErrorWorkshopContentsData = () => {
  return createSelector(
    workshopContentsRaw,
    (workshopChapterReducer) => workshopChapterReducer.error
  );
}

/**
 * when select specific content, return the content
 */
export const makeWorkshopContentsDataByIdSelector = (id: number) => {
  return createSelector(
    workshopContentsRaw,
    (workshopChapterReducer) => {
      return workshopChapterReducer.workshopContents[id] || []
    }
  );
};

/**
 * select the progress data
 */
export const makeWorkshopContentsProgressByIdSelector = (id: number) => {
  return createSelector(
    workshopContentsRaw,
    (workshopChapterReducer) => workshopChapterReducer.workshopProgress[id]
  );
};

/**
 * when select specific content, return the content
 */
export const makeWorkshopDataById = (id: number) => {
  return createSelector(
    makeWorkshopContentsDataByIdSelector(id),
    (data: Chapter[]) => {
      const result = data.reduce((acc: Module[], cur) => {
        const newAry: Module[] = cur.modules.map((v) => {
          const theObj: any = {
            type: v.type
          };

          if (v.type === ModuleType.VIDEO) {
            theObj.vodId = v.vodId;
            theObj.videoUrl = v.videoUrls;
          } else if (v.type === ModuleType.LAB) {
            theObj.labId = v.labId;
          } else if (v.type === ModuleType.QUIZ) {
            theObj.quizId = v.quizId;
            theObj.examData = v.examData;
            theObj.answers = v.answers;
            theObj.explains = v.explains;
          }

          return theObj;
        });

        return acc.concat(newAry);
      }, []);

      return result;
    }
  );
};

/**
 * when select specific content, return the note
 */
export const makeWorkshopNotesDataByIdSelector = (id: number, vodId: number): Selector<RootState, Note[]> => {
  return createSelector(
    workshopContentsRaw,
    (workshopContentsReducer) => {
      const list = workshopContentsReducer.workshopNotes[id] || [];
      return list.filter((note:Note) => vodId ? note.vodId === vodId : true);
    }
  );
};

/**
 * when fetching, set loading state
 */
export const makeIsFetchingWorkshopNotesData = (): Selector<RootState, boolean> => {
  return createSelector(
    workshopContentsRaw,
    (workshopContentsReducer) => workshopContentsReducer.isNotesLoading
  );
};

/**
 * return note error
 */
export const makeNoteErrorWorkshopNotesData = (): Selector<RootState, Error | undefined> => {
  return createSelector(
    workshopContentsRaw,
    (workshopContentsReducer) => workshopContentsReducer.noteError
  );
};

/**
 * when select specific content, return the progress
 */
export const makeWorkshopProgressDataByIdSelector = (id: number): Selector<RootState, Progress[]> => {
  return createSelector(
    workshopContentsRaw,
    (workshopContentsReducer) => {
      return workshopContentsReducer.workshopProgress[id] || []
    }
  );
};

/**
 * when select specific content, return has course
 */
export const makeWorkshopHasCourseByIdSelector = (id: number): Selector<RootState, boolean> => {
  return createSelector(
    workshopContentsRaw,
    (workshopContentsReducer) => true
  );
};
